<template>
  <div :class="rootClass">
    <b-card
        :class="rootClass + '__card'"
        class="bg-transparent border border-danger pl-2 rounded-5"
    >
      <div class="justify-content-end float-right">
        <div
            class="closeContentButton "
            style="padding: 2px"
            @click="closeContentTab"
        >
          <img
              v-if="$router.currentRoute.name === 'subscriber-information-lookup'"
              src="@/assets/images/icons/Vector.svg"
              style="width: 18px; height: 18px;margin-left: 8px;"
          />
        </div>
        <DropMenu
            :class="rootClass + '__menu-right-group'"
            @openTab="openTab"
        />
      </div>
      <b-row
          class="custom-scroll mb-2 mt-1 overflow-auto"
          style="padding-bottom: 3px"
      >
        <div
            class="d-flex"
            style="border-radius: 17px; border: 1px #E9182C solid;height: 35px"
        >
          <b-button
              v-for="tab in tabs"
              :key="tab.value"
              :class="[
              rootClass + '__subscriber-information-btn',
              tab.value === currentTab ? 'active' : 'inActive'
            ]"
              class="d-flex subscriberBtn"
              style="align-items: center; justify-content: space-between;border-top:none;border-bottom: none;
              border-right: none;border-left:3px solid  ; color: black;"
              variant="danger"
              @click="changeTab(tab)"
          >
            <span style="min-width: 190px">{{ tab.text }}</span>
            <img
                v-show="tab.value === currentTab"
                src="@/assets/images/svg/XCircle.svg"
                style="margin-left: 2%"
                @click="closeTab(tab.value)"
            />
          </b-button>
        </div>
      </b-row>
      <keep-alive>
        <component
            :is="currentTab"
            :msinSearchNumber="msinSearchNumber"
            :noNumberSearch="noNumberSearch"
            :searchPhone="searchPhoneNum"
            class="tab"
            @searchTTTB="searchTTTB"
        ></component>
      </keep-alive>
    </b-card>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import SubscriberInformation from "@/views/subscriber/SubscriberInformation.vue";
import SearchCRS from "@/views/subscriber/SearchCRS.vue";
import SearchPackage from "@/views/subscriber/SearchPackage.vue";
import SearchListHistory from "@/views/subscriber/SearchListHistory.vue";
import MsinToMsisdn from "@/views/subscriber/MsinToMsisdn.vue";
import NoNumberToMsindn from "@/views/subscriber/NoNumberToMsindn.vue";
import DkttHistory from "@/views/subscriber/DkttHistory.vue";
import subMGM from "@/views/subscriber/SubMGM.vue";
import MemberPack from "@/views/subscriber/MemberPack.vue";
import PackageHistory from "@/views/subscriber/PackageHistory.vue";
import CdrByMonth from "@/views/subscriber/CdrByMonth.vue";
import PackageDetail from "@/views/subscriber/PackageDetail.vue";
import RechargeHistory from "@/views/subscriber/RechargeHistory.vue";
import CountCallsByDateRange from "@/views/subscriber/CountCallsByDateRange.vue";
import SmoSmtHistory from "@/views/subscriber/SmoSmtHistory.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    DropMenu,
    SubscriberInformation,
    SearchCRS,
    SearchPackage,
    SearchListHistory,
    MsinToMsisdn,
    NoNumberToMsindn,
    DkttHistory,
    subMGM,
    MemberPack,
    PackageHistory,
    CdrByMonth,
    PackageDetail,
    RechargeHistory,
    CountCallsByDateRange,
    SmoSmtHistory
  },
  computed: {},
  data() {
    return {
      rootClass: "subscriber-information",
      currentTab: "",
      tabs: [],
      searchPhoneNum: "",
      tabOpen: localStorage.getItem("tabOpen"),
      msinSearchNumber: "",
      noNumberSearch: ""
    };
  },
  mounted() {
    switch (this.tabOpen) {
      case "SubscriberInformation":
        this.searchPhoneNum = 0 + localStorage.getItem("phoneNumberSearch");
        this.tabs.push({
          value: "SubscriberInformation",
          text: "Thông tin thuê bao"
        });
        this.currentTab = "SubscriberInformation";
        break;
      case "NoNumberToMsindn":
        this.noNumberSearch = localStorage.getItem("noNumberInput");
        this.tabs.push({
          value: "NoNumberToMsindn",
          text: "Tra cứu số CCCD ra SĐT"
        });
        this.currentTab = "NoNumberToMsindn";
        break;
      case "MsinToMsisdn":
        this.msinSearchNumber = localStorage.getItem("msinInput");
        this.tabs.push({
          value: "MsinToMsisdn",
          text: "Tra cứu Serial Sim ra số"
        });
        this.currentTab = "MsinToMsisdn";
        break;
    }
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab.value;
    },
    closeTab(value) {
      event.stopImmediatePropagation();
      this.tabs = this.tabs.filter(t => t.value != value);
      if (this.tabs.length === 0) {
        this.currentTab = "";
      } else {
        this.currentTab = this.tabs[0].value;
      }
    },
    openTab(tab) {
      this.tabs.forEach(t => {
        if (t.value === tab.value) {
          this.currentTab = tab.value;

        }
      });
      if (this.currentTab != tab.value) {
        this.currentTab = tab.value;
        this.tabs.push(tab);
      }
    },
    closeContentTab() {
      this.$emit("closeContentTab", false);
    },
    searchTTTB(seachPhoneNumberInfo) {
      console.log("tabOpen", seachPhoneNumberInfo);
      this.searchPhoneNum = seachPhoneNumberInfo.searchPhoneNumberEmit;
      console.log("phone search", this.searchPhoneNum);
      this.openTab(seachPhoneNumberInfo.openTab);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.custom-scroll::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
  height: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #afafaf;
}

.--border-dashed {
  border-style: dashed;
}

.--input {
  font-size: 12px;
  background: #fcfcfc;
  height: 23px;
  width: 68%;
  padding: 0.438rem 0.5rem;
}

label {
  width: 28%;
  margin-bottom: 0;
  font-size: 13px;
}

.closeContentButton:hover {
  cursor: pointer;
  box-shadow: 0px 2.51907px 5.6679px rgb(0 0 0 / 25%);
}

.subscriber-information {
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background-color: white !important;
  }

  &__national-code-input {
    width: 7%;
    margin-right: 6px;
  }

  &__phone-input {
    width: 60%;
  }

  &__sim-commit-label {
    width: 40%;
  }

  &__sim-commit-input {
    width: 45%;
    margin-right: 6px;
  }

  &__sim-commit-month-input {
    width: 10%;
  }

  &__pack-commit-input {
    width: 14%;
  }

  &__pack-commit-month-input {
    width: 15%;
  }

  &__time-commit-remain-label {
    width: 36%;
    margin-left: 17px;
  }

  &__self-input {
    width: 24%;
  }

  &__date-of-birth-input {
    width: 24%;
  }

  &__date-of-birth-label {
    width: 18%;
    margin-left: 11px;
  }

  &__doc-type-input {
    width: 24%;
  }

  &__issue-date-label {
    width: 18%;
    margin-left: 11px;
  }

  &__issue-date-input {
    width: 24%;
  }

  &__card-number-input {
    width: 24%;
  }

  &__issue-by-label {
    width: 18%;
    margin-left: 11px;
  }

  &__issue-by-input {
    width: 24%;
  }

  &__subscriber-information-btn {
    border-radius: 17px;
  }

  &__approval-status-label {
    margin-bottom: 0;
  }

  &__add-complain-btn {
    border-radius: 17px;
  }

  &__complain-history-btn {
    border-radius: 17px;
  }

  &__service-table {
    background: white;
    border-radius: 12px;
    box-shadow: 0px 2.51907px 5.6679px rgb(0 0 0 / 25%);
    width: 100%;
    text-align: center;

    .--first-th {
      background: red;
      border-radius: 12px 0px 0px 0px;
    }

    .--last-th {
      background: red;
      border-radius: 0px 12px 0px 0px;
    }
  }

  &__menu-right-group {
    //position: absolute;
    //top: 150px;
    //right: 20px;
  }
}

.inActive {
  background: white !important;
  color: #707070;
}

.subscriberBtn {
  padding: 0.2rem 0.5rem;
  font-weight: bold;
  font-size: 14px;
  color: #707070 !important;
}

.active {
  background: #ed1f24 !important;
  color: white !important;
}

.tab {
  padding-left: 1rem;
  max-height: 68vh;
  overflow-y: scroll;
  width: auto;
}

.tab::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.tab::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
  height: 10px;
}

.tab::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d7d7d7;
}

@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 576px) {
  .--input {
    width: 100%;
  }

  label {
    width: 100%;
  }

  .subscriber-information {
    &__national-code-input {
      width: 18%;
      margin-right: 5px;
    }

    &__phone-input {
      width: 80%;
    }

    &__sim-commit-label {
      width: 100%;
    }

    &__sim-commit-input {
      width: 88%;
      margin-right: 5px;
    }

    &__sim-commit-month-input {
      width: 10%;
    }

    &__pack-commit-input {
      margin-bottom: 0.8rem;
    }

    &__time-commit-remain-label {
      width: 100%;
      margin-left: 0rem;
    }

    &__self-input {
      margin-bottom: 0.8rem;
    }

    &__date-of-birth-label {
      width: 100%;
      margin-left: 0px;
    }

    &__doc-type-input {
      margin-bottom: 0.8rem;
    }

    &__issue-date-label {
      margin-left: 0rem;
      width: 100%;
    }

    &__card-number-input {
      margin-bottom: 0.8rem;
    }

    &__issue-by-label {
      margin-left: 0rem;
      width: 100%;
    }
  }
}
</style>
